exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workTime-editModal .time-setting {\n  line-height: 32px;\n}\n.workTime-editModal .time-setting .ant-time-picker {\n  width: 100%;\n}\n.workTime-editModal .time-setting .anticon {\n  cursor: pointer;\n}\n", ""]);

// exports
